import React, { useState, useEffect, useCallback } from "react";
import api from "../services/api";
import { useAuth } from "../context/AuthContext";
import { usePageState } from "../context/AppStateContext";
import { useMessageBox } from "../components/Common/MessageBox";
import "./GeneralSettingPage.css";
import { MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon } from "mdb-react-ui-kit";

// ================= COMPLETE CURRENCIES LIST =================
const CURRENCIES = [
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "GBP", name: "British Pound", symbol: "£" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$" },
  { code: "CHF", name: "Swiss Franc", symbol: "Fr" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
  { code: "INR", name: "Indian Rupee", symbol: "₹" },
  { code: "AED", name: "UAE Dirham", symbol: "د.إ" },
  { code: "AFN", name: "Afghan Afghani", symbol: "؋" },
  { code: "ALL", name: "Albanian Lek", symbol: "L" },
  { code: "AMD", name: "Armenian Dram", symbol: "֏" },
  { code: "ANG", name: "Netherlands Antillian Guilder", symbol: "ƒ" },
  { code: "AOA", name: "Angolan Kwanza", symbol: "Kz" },
  { code: "ARS", name: "Argentine Peso", symbol: "$" },
  { code: "AWG", name: "Aruban Florin", symbol: "ƒ" },
  { code: "AZN", name: "Azerbaijani Manat", symbol: "₼" },
  { code: "BAM", name: "Bosnia and Herzegovina Mark", symbol: "KM" },
  { code: "BBD", name: "Barbados Dollar", symbol: "Bds$" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳" },
  { code: "BGN", name: "Bulgarian Lev", symbol: "лв" },
  { code: "BHD", name: "Bahraini Dinar", symbol: ".د.ب" },
  { code: "BIF", name: "Burundian Franc", symbol: "FBu" },
  { code: "BMD", name: "Bermudian Dollar", symbol: "$" },
  { code: "BND", name: "Brunei Dollar", symbol: "B$" },
  { code: "BOB", name: "Bolivian Boliviano", symbol: "Bs." },
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "BSD", name: "Bahamian Dollar", symbol: "B$" },
  { code: "BTN", name: "Bhutanese Ngultrum", symbol: "Nu." },
  { code: "BWP", name: "Botswana Pula", symbol: "P" },
  { code: "BYN", name: "Belarusian Ruble", symbol: "Br" },
  { code: "BZD", name: "Belize Dollar", symbol: "BZ$" },
  { code: "CDF", name: "Congolese Franc", symbol: "FC" },
  { code: "CLP", name: "Chilean Peso", symbol: "$" },
  { code: "COP", name: "Colombian Peso", symbol: "$" },
  { code: "CRC", name: "Costa Rican Colón", symbol: "₡" },
  { code: "CUP", name: "Cuban Peso", symbol: "$" },
  { code: "CVE", name: "Cape Verdean Escudo", symbol: "$" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "DJF", name: "Djiboutian Franc", symbol: "Fdj" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "DOP", name: "Dominican Peso", symbol: "RD$" },
  { code: "DZD", name: "Algerian Dinar", symbol: "د.ج" },
  { code: "EGP", name: "Egyptian Pound", symbol: "E£" },
  { code: "ERN", name: "Eritrean Nakfa", symbol: "Nfk" },
  { code: "ETB", name: "Ethiopian Birr", symbol: "Br" },
  { code: "FJD", name: "Fijian Dollar", symbol: "FJ$" },
  { code: "FKP", name: "Falkland Islands Pound", symbol: "£" },
  { code: "FOK", name: "Faroese Króna", symbol: "kr" },
  { code: "GEL", name: "Georgian Lari", symbol: "₾" },
  { code: "GGP", name: "Guernsey Pound", symbol: "£" },
  { code: "GHS", name: "Ghanaian Cedi", symbol: "₵" },
  { code: "GIP", name: "Gibraltar Pound", symbol: "£" },
  { code: "GMD", name: "Gambian Dalasi", symbol: "D" },
  { code: "GNF", name: "Guinean Franc", symbol: "FG" },
  { code: "GTQ", name: "Guatemalan Quetzal", symbol: "Q" },
  { code: "GYD", name: "Guyanese Dollar", symbol: "G$" },
  { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
  { code: "HNL", name: "Honduran Lempira", symbol: "L" },
  { code: "HRK", name: "Croatian Kuna", symbol: "kn" },
  { code: "HTG", name: "Haitian Gourde", symbol: "G" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
  { code: "ILS", name: "Israeli New Shekel", symbol: "₪" },
  { code: "IMP", name: "Isle of Man Pound", symbol: "£" },
  { code: "IQD", name: "Iraqi Dinar", symbol: "ع.د" },
  { code: "IRR", name: "Iranian Rial", symbol: "﷼" },
  { code: "ISK", name: "Icelandic Króna", symbol: "kr" },
  { code: "JEP", name: "Jersey Pound", symbol: "£" },
  { code: "JMD", name: "Jamaican Dollar", symbol: "J$" },
  { code: "JOD", name: "Jordanian Dinar", symbol: "د.ا" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh" },
  { code: "KGS", name: "Kyrgyzstani Som", symbol: "с" },
  { code: "KHR", name: "Cambodian Riel", symbol: "៛" },
  { code: "KID", name: "Kiribati Dollar", symbol: "$" },
  { code: "KMF", name: "Comorian Franc", symbol: "CF" },
  { code: "KRW", name: "South Korean Won", symbol: "₩" },
  { code: "KWD", name: "Kuwaiti Dinar", symbol: "د.ك" },
  { code: "KYD", name: "Cayman Islands Dollar", symbol: "CI$" },
  { code: "KZT", name: "Kazakhstani Tenge", symbol: "₸" },
  { code: "LAK", name: "Lao Kip", symbol: "₭" },
  { code: "LBP", name: "Lebanese Pound", symbol: "ل.ل" },
  { code: "LKR", name: "Sri Lankan Rupee", symbol: "Rs" },
  { code: "LRD", name: "Liberian Dollar", symbol: "L$" },
  { code: "LSL", name: "Lesotho Loti", symbol: "L" },
  { code: "LYD", name: "Libyan Dinar", symbol: "ل.د" },
  { code: "MAD", name: "Moroccan Dirham", symbol: "د.م." },
  { code: "MDL", name: "Moldovan Leu", symbol: "L" },
  { code: "MGA", name: "Malagasy Ariary", symbol: "Ar" },
  { code: "MKD", name: "Macedonian Denar", symbol: "ден" },
  { code: "MMK", name: "Burmese Kyat", symbol: "K" },
  { code: "MNT", name: "Mongolian Tögrög", symbol: "₮" },
  { code: "MOP", name: "Macanese Pataca", symbol: "MOP$" },
  { code: "MRU", name: "Mauritanian Ouguiya", symbol: "UM" },
  { code: "MUR", name: "Mauritian Rupee", symbol: "₨" },
  { code: "MVR", name: "Maldivian Rufiyaa", symbol: "Rf" },
  { code: "MWK", name: "Malawian Kwacha", symbol: "MK" },
  { code: "MXN", name: "Mexican Peso", symbol: "$" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
  { code: "MZN", name: "Mozambican Metical", symbol: "MT" },
  { code: "NAD", name: "Namibian Dollar", symbol: "N$" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦" },
  { code: "NIO", name: "Nicaraguan Córdoba", symbol: "C$" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "NPR", name: "Nepalese Rupee", symbol: "₨" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
  { code: "OMR", name: "Omani Rial", symbol: "ر.ع." },
  { code: "PAB", name: "Panamanian Balboa", symbol: "B/." },
  { code: "PEN", name: "Peruvian Sol", symbol: "S/." },
  { code: "PGK", name: "Papua New Guinean Kina", symbol: "K" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱" },
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨" },
  { code: "PLN", name: "Polish Złoty", symbol: "zł" },
  { code: "PYG", name: "Paraguayan Guaraní", symbol: "₲" },
  { code: "QAR", name: "Qatari Riyal", symbol: "ر.ق" },
  { code: "RON", name: "Romanian Leu", symbol: "lei" },
  { code: "RSD", name: "Serbian Dinar", symbol: "дин." },
  { code: "RUB", name: "Russian Ruble", symbol: "₽" },
  { code: "RWF", name: "Rwandan Franc", symbol: "FRw" },
  { code: "SAR", name: "Saudi Riyal", symbol: "ر.س" },
  { code: "SBD", name: "Solomon Islands Dollar", symbol: "SI$" },
  { code: "SCR", name: "Seychellois Rupee", symbol: "₨" },
  { code: "SDG", name: "Sudanese Pound", symbol: "ج.س." },
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
  { code: "SHP", name: "Saint Helena Pound", symbol: "£" },
  { code: "SLL", name: "Sierra Leonean Leone", symbol: "Le" },
  { code: "SOS", name: "Somali Shilling", symbol: "Sh" },
  { code: "SRD", name: "Surinamese Dollar", symbol: "$" },
  { code: "SSP", name: "South Sudanese Pound", symbol: "£" },
  { code: "STN", name: "São Tomé and Príncipe Dobra", symbol: "Db" },
  { code: "SYP", name: "Syrian Pound", symbol: "£" },
  { code: "SZL", name: "Eswatini Lilangeni", symbol: "L" },
  { code: "THB", name: "Thai Baht", symbol: "฿" },
  { code: "TJS", name: "Tajikistani Somoni", symbol: "ЅМ" },
  { code: "TMT", name: "Turkmenistani Manat", symbol: "m" },
  { code: "TND", name: "Tunisian Dinar", symbol: "د.ت" },
  { code: "TOP", name: "Tongan Paʻanga", symbol: "T$" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺" },
  { code: "TTD", name: "Trinidad and Tobago Dollar", symbol: "TT$" },
  { code: "TVD", name: "Tuvaluan Dollar", symbol: "$" },
  { code: "TWD", name: "New Taiwan Dollar", symbol: "NT$" },
  { code: "TZS", name: "Tanzanian Shilling", symbol: "TSh" },
  { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴" },
  { code: "UGX", name: "Ugandan Shilling", symbol: "USh" },
  { code: "UYU", name: "Uruguayan Peso", symbol: "$" },
  { code: "UZS", name: "Uzbekistani So'm", symbol: "so'm" },
  { code: "VES", name: "Venezuelan Bolívar", symbol: "Bs." },
  { code: "VND", name: "Vietnamese Đồng", symbol: "₫" },
  { code: "VUV", name: "Vanuatu Vatu", symbol: "VT" },
  { code: "WST", name: "Samoan Tālā", symbol: "WS$" },
  { code: "XAF", name: "Central African CFA Franc", symbol: "FCFA" },
  { code: "XCD", name: "East Caribbean Dollar", symbol: "EC$" },
  { code: "XOF", name: "West African CFA Franc", symbol: "CFA" },
  { code: "XPF", name: "CFP Franc", symbol: "₣" },
  { code: "YER", name: "Yemeni Rial", symbol: "﷼" },
  { code: "ZAR", name: "South African Rand", symbol: "R" },
  { code: "ZMW", name: "Zambian Kwacha", symbol: "ZK" },
  { code: "ZWL", name: "Zimbabwean Dollar", symbol: "Z$" }
];

// ================= DESCRIPTION STYLES =================
const DESCRIPTION_STYLES = [
  {
    value: "ai_seo_friendly_desc",
    label: "AI SEO Friendly Description",
    hint: "Will include your store URL and location in description",
  },
  {
    value: "html_ai_seo_desc",
    label: "HTML AI SEO Description",
    hint: "Will include SKU in HTML formatted description",
  },
  {
    value: "text_formatted_desc",
    label: "Text Formatted Description",
    hint: "Paragraph text then product information",
  },
  {
    value: "html_formatted_desc",
    label: "HTML Formatted Description",
    hint: "HTML paragraphs with product details",
  },
  {
    value: "custom_desc",
    label: "Custom Description",
    hint: "Your own description template",
  },
];

// ================= TITLE STYLES =================
const TITLE_STYLES = [
  {
    value: "ai_seo_friendly_title",
    label: "AI SEO Friendly Title",
    hint: "SEO optimized title with keywords",
  },
  {
    value: "html_ai_seo_title",
    label: "HTML AI SEO Title",
    hint: "HTML title with SKU",
  },
  {
    value: "text_formatted_title",
    label: "Text Formatted Title",
    hint: "Simple formatted title text",
  },
  {
    value: "html_formatted_title",
    label: "HTML Formatted Title",
    hint: "Title with HTML formatting",
  },
  {
    value: "custom_title",
    label: "Custom Title",
    hint: "Your own title template",
  },
];

// ================= TAGS STYLES =================
const TAGS_STYLES = [
  {
    value: "ai_seo_friendly_tags",
    label: "AI SEO Friendly Tags",
    hint: "AI generated SEO optimized tags",
  },
  {
    value: "category_based_tags",
    label: "Category Based Tags",
    hint: "Tags based on product categories",
  },
  {
    value: "keyword_tags",
    label: "Keyword Based Tags",
    hint: "Tags extracted from product keywords",
  },
  {
    value: "custom_tags",
    label: "Custom Tags",
    hint: "Your own tag template",
  },
];

const GeneralSettingPage = () => {
  const { setState: setPersistedState } = usePageState("generalSettings");
  const { showError, showSuccess, showWarning, MessageBoxComponent } =
    useMessageBox();

  // Initialize settings
  const [settings, setSettings] = useState({
    username: "",
    companyName: "",
    currency: "",
    skuFormat: "",
    descriptionStyle: "text_formatted_desc",
    descriptionPrompt: "",
    titleStyle: "text_formatted_title",
    titlePrompt: "",
    tagsStyle: "category_based_tags",
    tagsPrompt: "",
  });

  const [vendors, setVendors] = useState([]);
  const [newVendor, setNewVendor] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const { companyId } = useAuth();

  // ================= Parse combined value helper =================
  const parseCombinedValue = useCallback((combinedValue) => {
    console.log("🔄 Parsing combined value:", combinedValue);
    
    if (!combinedValue || combinedValue === '') {
      return { style: '', prompt: '' };
    }

    if (combinedValue.includes("|||")) {
      const parts = combinedValue.split("|||");
      return {
        style: parts[0] || '',
        prompt: parts[1] || '',
      };
    }

    return {
      style: combinedValue,
      prompt: '',
    };
  }, []);

  // ================= Get currency display name =================
  const getCurrencyDisplay = (code) => {
    const currency = CURRENCIES.find(c => c.code === code);
    return currency ? `${currency.code} - ${currency.name} (${currency.symbol})` : code;
  };

  // ================= Get placeholders =================
  const getDescriptionPlaceholder = useCallback(() => {
    switch (settings.descriptionStyle) {
      case "ai_seo_friendly_desc":
        return "AI will add store URL and location automatically. Add any specific keywords...";
      case "html_ai_seo_desc":
        return "HTML description with SKU. Example: <p>Product details with SKU: [SKU]</p>";
      case "text_formatted_desc":
        return "Start with paragraph about product, then list features...";
      case "html_formatted_desc":
        return "HTML format. Example: <p>Product description</p><p>Color variations...</p>";
      case "custom_desc":
        return "Enter your custom description template. Use placeholders...";
      default:
        return "Enter description pattern...";
    }
  }, [settings.descriptionStyle]);

  const getTitlePlaceholder = useCallback(() => {
    switch (settings.titleStyle) {
      case "ai_seo_friendly_title":
        return "AI optimized title. Add keywords for SEO...";
      case "html_ai_seo_title":
        return "HTML title with SKU. Example: <strong>Product Name</strong> - SKU: [SKU]";
      case "text_formatted_title":
        return "Simple title format. Example: Brand | Model | Color";
      case "html_formatted_title":
        return "HTML title. Example: <h1>Product Name</h1>";
      case "custom_title":
        return "Enter your custom title template...";
      default:
        return "Enter title pattern...";
    }
  }, [settings.titleStyle]);

  const getTagsPlaceholder = useCallback(() => {
    switch (settings.tagsStyle) {
      case "ai_seo_friendly_tags":
        return "AI will generate SEO friendly tags based on product description...";
      case "category_based_tags":
        return "Tags will be generated based on product category and subcategories...";
      case "keyword_tags":
        return "Enter keywords separated by commas...";
      case "custom_tags":
        return "Enter custom tag template...";
      default:
        return "Enter tag generation instructions...";
    }
  }, [settings.tagsStyle]);

  // ================= Fetch settings =================
  useEffect(() => {
    const fetchSettings = async () => {
      if (!companyId || hasFetched) {
        return;
      }

      try {
        console.log("🔍 Fetching settings for company:", companyId);
        const res = await api.get(`/api/general-settings/${companyId}`);

        const data = res.data || {};
        console.log("📥 Fetched data from API:", data);

        const descriptionParsed = parseCombinedValue(data.description_style);
        const titleParsed = parseCombinedValue(data.title_style);
        const tagsParsed = parseCombinedValue(data.tags_style);

        setSettings({
          username: data.username || "",
          companyName: data.company_name || "",
          currency: data.currency || "",
          skuFormat: data.sku_format || "",
          descriptionStyle: descriptionParsed.style || "text_formatted_desc",
          descriptionPrompt: descriptionParsed.prompt || "",
          titleStyle: titleParsed.style || "text_formatted_title",
          titlePrompt: titleParsed.prompt || "",
          tagsStyle: tagsParsed.style || "category_based_tags",
          tagsPrompt: tagsParsed.prompt || "",
        });

        const vendorArray = data.vendor_list
          ? data.vendor_list.split(",").filter((v) => v.trim() !== "")
          : [];
        setVendors(vendorArray);

        setHasFetched(true);
        setLoading(false);
      } catch (err) {
        console.error("❌ Failed to fetch settings:", err);
        showError("Failed to fetch settings. Please try again.");
        setLoading(false);
      }
    };

    fetchSettings();
  }, [companyId, parseCombinedValue, hasFetched, showError]);

  // ================= Sync to context =================
  useEffect(() => {
    if (!hasFetched) return;
    
    const { username, companyName, ...persistableSettings } = settings;
    setPersistedState({
      settings: persistableSettings,
      vendors,
      newVendor,
    });
  }, [settings, vendors, newVendor, setPersistedState, hasFetched]);

  // ================= Event Handlers =================
  const handleChange = useCallback((key, value) => {
    console.log(`✏️ Changing ${key}:`, value);
    setSettings((prev) => ({ ...prev, [key]: value }));
  }, []);

  const addVendor = useCallback(() => {
    const trimmed = newVendor.trim();
    if (!trimmed) {
      showWarning("Please enter vendor name");
      return;
    }
    if (vendors.includes(trimmed)) {
      showWarning("Vendor already exists in the list");
      return;
    }
    setVendors((prev) => [...prev, trimmed]);
    setNewVendor("");
  }, [newVendor, vendors, showWarning]);

  const removeVendor = useCallback((index) => {
    setVendors((prev) => prev.filter((_, i) => i !== index));
  }, []);

  // ================= Save Settings =================
  const handleSave = async () => {
    if (!companyId) {
      showError("Company ID is missing. Please refresh the page.");
      return;
    }

    setSaving(true);
    
    try {
      const descriptionCombined = `${settings.descriptionStyle}|||${settings.descriptionPrompt}`;
      const titleCombined = `${settings.titleStyle}|||${settings.titlePrompt}`;
      const tagsCombined = `${settings.tagsStyle}|||${settings.tagsPrompt}`;

      console.log("📤 Saving payload:", {
        currency: settings.currency,
        skuFormat: settings.skuFormat,
        vendors: vendors,
        description: descriptionCombined,
        title: titleCombined,
        tags: tagsCombined
      });

      const payload = {
        currency: settings.currency,
        sku_format: settings.skuFormat,
        vendor_list: vendors.join(","),
        description_style: descriptionCombined,
        title_style: titleCombined,
        tags_style: tagsCombined,
      };

      await api.put(`/api/general-settings/${companyId}`, payload);
      showSuccess("Settings saved successfully!");
      
    } catch (err) {
      console.error("❌ Save error:", err);
      showError(err.response?.data?.message || "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading settings...</p>
      </div>
    );
  }

  return (
    <div className="settings-page">
      <h1 className="page-title">Account Settings</h1>

      {/* Account Info */}
      <div className="settings-card">
        <h4><MDBIcon icon="user" className="me-2" />Account Info</h4>
        <MDBRow>
          <MDBCol md="6">
            <MDBInput 
              label="Username" 
              value={settings.username} 
              disabled 
              className="mb-3"
            />
          </MDBCol>
          <MDBCol md="6">
            <MDBInput
              label="Company Name"
              value={settings.companyName}
              onChange={(e) => handleChange("companyName", e.target.value)}
              className="mb-3"
            />
          </MDBCol>
        </MDBRow>
      </div>

      {/* Listing Settings with Currency Dropdown */}
      <div className="settings-card">
        <h4><MDBIcon icon="cog" className="me-2" />Listing Settings</h4>
        <MDBRow>
          <MDBCol md="6">
            <div className="mb-3">
              <label className="form-label fw-bold">Currency</label>
              <select
                className="form-select"
                value={settings.currency}
                onChange={(e) => handleChange("currency", e.target.value)}
              >
                <option value="">Select Currency</option>
                {CURRENCIES.map((currency) => (
                  <option key={currency.code} value={currency.code}>
                    {currency.code} - {currency.name} ({currency.symbol})
                  </option>
                ))}
              </select>
              {settings.currency && (
                <div className="form-text text-success">
                  Selected: {getCurrencyDisplay(settings.currency)}
                </div>
              )}
            </div>
          </MDBCol>
          <MDBCol md="6">
            <MDBInput
              label="SKU Format"
              value={settings.skuFormat}
              onChange={(e) => handleChange("skuFormat", e.target.value)}
              placeholder="e.g., BRAND-MODEL-COLOR"
              className="mb-3"
            />
          </MDBCol>
        </MDBRow>
      </div>

      {/* Vendors */}
      <div className="settings-card">
        <h4><MDBIcon icon="store" className="me-2" />Vendor List</h4>
        <div className="vendor-input-group">
          <MDBInput
            label="Add Vendor"
            value={newVendor}
            onChange={(e) => setNewVendor(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addVendor();
              }
            }}
            className="mb-2"
          />
          <MDBBtn color="primary" onClick={addVendor} className="mb-3">
            <MDBIcon icon="plus" className="me-1" />
            Add Vendor
          </MDBBtn>
        </div>

        {vendors.length > 0 ? (
          <div className="vendor-list mt-3">
            {vendors.map((vendor, index) => (
              <div
                key={index}
                className="vendor-item d-flex justify-content-between align-items-center p-2 mb-2 border rounded"
              >
                <span className="vendor-name">{vendor}</span>
                <MDBBtn
                  size="sm"
                  color="danger"
                  onClick={() => removeVendor(index)}
                  className="vendor-remove-btn"
                >
                  <MDBIcon icon="trash" />
                </MDBBtn>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted mt-3">No vendors added yet.</p>
        )}
      </div>

      {/* DESCRIPTION SETTINGS */}
      <div className="settings-card">
        <h4><MDBIcon icon="file-alt" className="me-2" />Description Generation</h4>

        <div className="mb-3">
          <label className="form-label fw-bold">Description Style</label>
          <select
            className="form-select"
            value={settings.descriptionStyle}
            onChange={(e) => handleChange("descriptionStyle", e.target.value)}
          >
            {DESCRIPTION_STYLES.map((opt) => (
              <option key={`desc-${opt.value}`} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <div className="form-text text-muted">
            {DESCRIPTION_STYLES.find(opt => opt.value === settings.descriptionStyle)?.hint}
          </div>
        </div>

        <div className="mt-3">
          <label className="form-label fw-bold">Description Prompt</label>
          <textarea
            className="form-control"
            rows={3}
            placeholder={getDescriptionPlaceholder()}
            value={settings.descriptionPrompt}
            onChange={(e) => handleChange("descriptionPrompt", e.target.value)}
            style={{ resize: "vertical" }}
          />
          <div className="form-text text-muted">
            Customize description generation. Use placeholders like [PRODUCT_NAME], [SKU]
          </div>
        </div>
      </div>

      {/* TITLE SETTINGS */}
      <div className="settings-card">
        <h4><MDBIcon icon="heading" className="me-2" />Title Generation</h4>

        <div className="mb-3">
          <label className="form-label fw-bold">Title Style</label>
          <select
            className="form-select"
            value={settings.titleStyle}
            onChange={(e) => handleChange("titleStyle", e.target.value)}
          >
            {TITLE_STYLES.map((opt) => (
              <option key={`title-${opt.value}`} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <div className="form-text text-muted">
            {TITLE_STYLES.find(opt => opt.value === settings.titleStyle)?.hint}
          </div>
        </div>

        <div className="mt-3">
          <label className="form-label fw-bold">Title Prompt</label>
          <textarea
            className="form-control"
            rows={2}
            placeholder={getTitlePlaceholder()}
            value={settings.titlePrompt}
            onChange={(e) => handleChange("titlePrompt", e.target.value)}
            style={{ resize: "vertical" }}
          />
          <div className="form-text text-muted">
            Customize title generation. Keep it SEO friendly.
          </div>
        </div>
      </div>

      {/* TAGS SETTINGS */}
      <div className="settings-card">
        <h4><MDBIcon icon="tags" className="me-2" />Tags Generation</h4>

        <div className="mb-3">
          <label className="form-label fw-bold">Tags Style</label>
          <select
            className="form-select"
            value={settings.tagsStyle}
            onChange={(e) => handleChange("tagsStyle", e.target.value)}
          >
            {TAGS_STYLES.map((opt) => (
              <option key={`tags-${opt.value}`} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <div className="form-text text-muted">
            {TAGS_STYLES.find(opt => opt.value === settings.tagsStyle)?.hint}
          </div>
        </div>

        <div className="mt-3">
          <label className="form-label fw-bold">Tags Prompt</label>
          <textarea
            className="form-control"
            rows={2}
            placeholder={getTagsPlaceholder()}
            value={settings.tagsPrompt}
            onChange={(e) => handleChange("tagsPrompt", e.target.value)}
            style={{ resize: "vertical" }}
          />
          <div className="form-text text-muted">
            Customize tag generation. Separate multiple tags with commas.
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="save-section text-center mt-4 p-4 border-top">
        <MDBBtn
          color="success"
          size="lg"
          onClick={handleSave}
          disabled={saving}
          style={{ minWidth: "250px" }}
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Saving...
            </>
          ) : (
            <>
              <MDBIcon icon="save" className="me-2" />
              Save All Settings
            </>
          )}
        </MDBBtn>
        <p className="text-muted mt-2">
          Your settings will be automatically applied to all new product listings.
        </p>
      </div>

      <MessageBoxComponent />
    </div>
  );
};

export default GeneralSettingPage;